import { React, useState } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { changeLanguage, changeView } from '../Store/viewSlice';
import translate from '../translate';

function Header () {
  const dispatch = useDispatch();
  const sideInfoOpen = useSelector(state => state.view.sideInfoOpen);
  const language = useSelector(state => state.view.selectedLanguage);
  const componentName = 'header';
  function sideInfoTrigger(e, open) {
    e.preventDefault();
    dispatch(changeView({ sideInfoOpen: open }));
  }

  return (
    <>
      <header
        className='header pt-15 pb-15'
        data-uk-sticky='top: 250; animation: uk-animation-slide-top;'
      >
        <div className='container-fluid container__fluid'>
          <div className='row'>
            <div className='col-xl-10 col-lg-4 col-sm-6 col-7 align-self-center'>
              <div className='logo-menu-wrapper'>
                <div className='header-logo'>
                  <Link to='/'>
                  <img
                    width="300"
                      src='./assets/img/logo/logo.png'
                      alt='AlpineSoft'
                    />
                  </Link>
                </div>
                <div className='menu-wrapper'>
                  <div className='main-menu'>
                    <nav id='navbar'>
                      <ul>
                        <li>
                          <Link to='/'>{translate(componentName, 'home', language)}</Link>
                        </li>
                        <li>
                          <Link to='/about'>{translate(componentName, 'about', language)}</Link>
                        </li>
                        <li>
                          <Link to='/services'>{translate(componentName, 'services', language)}</Link>
                        </li>
                        <li>
                          <Link to='/contact'>{translate(componentName, 'contact', language)}</Link>
                        </li>
                      </ul>
                    </nav>
                  </div>
                  <Link to='/contact' className='btn'>{translate(componentName, 'freeQuote', language)}<span></span></Link>
                </div>
              </div>
            </div>
            
            <div className='col-xl-2 col-lg-8 col-sm-6 col-5 align-self-center'>
              <div className='right-element'>
                <ul className='list-unstyled d-flex align-items-center'>
                  <li className='language-selector'>
                    <select
                      defaultValue={language}
                      onChange={(e) => {
                        dispatch(changeLanguage({ selectedLanguage: e.target.value })); 
                        console.log(e.target.value)
                      }}
                    >
                      <option value='en'>EN</option>
                      <option value='tr'>TR</option>
                      <option value='de'>DE</option>
                    </select>
                  </li>
                    <li className='sideinfo-trigger' onClick={(e)=>sideInfoTrigger(e,true)} data-sideinfo-trigger>
                    <span></span>
                    <span></span>
                    <span></span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </header>
    <div className={`overlay ${sideInfoOpen? 'is-open':''}`} onClick={(e)=>sideInfoTrigger(e,false)}></div>

    <div className="search-popup">
        <div className="color-layer"></div>
        <button className="close-search"><span className="far fa-arrow-up"></span></button>
        <form method="post" action="/blog">
            <div className="form-group">
                <input type="search" name="search-field" placeholder={translate(componentName, 'searchPlaceholder', language)} required=""/>
                <button type="submit"><i className="far fa-search"></i></button>
            </div>
        </form>
    </div>
    
    <aside className={`side-info-wrapper mm-only ${sideInfoOpen? 'is-open' : ''}`}>
        <nav>
            <div className="nav" id="nav-tab" role="tablist">
                <a className="nav-link active" id="menu-tab-1-tab" data-bs-toggle="tab"
                    href="#menu-tab-1" role="tab" aria-controls="menu-tab-1"
                    aria-selected="true">Menu</a>
                <a className="nav-link" id="menu-tab-2-tab" data-bs-toggle="tab" href="#menu-tab-2"
                    role="tab" aria-controls="menu-tab-2" aria-selected="false">Info</a>
            </div>
        </nav>
        <div className="side-info__wrapper d-flex align-items-center justify-content-between">
            <div className="side-info__logo">
                
                <Link to="/">
                    <img src="./assets/img/logo/logo.png" alt="logo"/>
                </Link>
            </div>
            <div className="side-info__close" onClick={(e)=>sideInfoTrigger(e,false)}>
                <Link to="#"><i className="far fa-times"></i></Link>
            </div>
        </div>
        <div className="tab-content" id="nav-tabContent">
            <div className="tab-pane fade show active" id="menu-tab-1" role="tabpanel"
                aria-labelledby="menu-tab-1-tab">
                <div className="search-box">
                    <form className="search-widget input-field position-relative" action="/blog" method="get">
                        <div>
                            <input type="search" required="" name="s" placeholder={translate(componentName, 'searchPlaceholder', language)}/>
                            <button type="submit"><i className="far fa-search"></i></button>
                        </div>
                    </form>
                </div>
                <div className="mobile-menu"></div>
            </div>
            <div className="tab-pane fade" id="menu-tab-2" role="tabpanel"
                aria-labelledby="menu-tab-2-tab">
                <div className="side-info">
                    <div className="side-info__content mb-35">
                        <h4 className="title">{translate(componentName, 'aboutUsTitle', language)}</h4>
                        <p>{translate(componentName, 'aboutUsDescription', language)}</p>
                        <Link className="btn btn__small mt-20" to="/contact">{translate(componentName, 'contactUsTitle', language)} <span></span></Link>
                    </div>
                    <div className="contact__info--wrapper mt-15">
                        <h4 className="title mb-15">{translate(componentName, 'contactUsTitle', language)}</h4>
                        <ul className="contact__info list-unstyled">
                            <li>
                                <span><i className="fas fa-map-marker-alt"></i></span>
                                <p>{translate(componentName, 'address', language)}</p>
                            </li>
                            <li>
                                <span><i className="fas fa-phone"></i></span>
                                <p><i className="far fa-phone-alt"></i> {translate(componentName, 'phone', language)}</p>
                            </li>
                            <li>
                                <span><i className="fas fa-envelope-open-text"></i></span>
                                <p>{translate(componentName, 'email', language)}</p>
                            </li>
                        </ul>
                    </div>
                    <div className="social-links mt-30">
                        <Link to="#0"><i className="fab fa-facebook-f"></i></Link>
                        <Link to="#0"><i className="fab fa-twitter"></i></Link>
                        <Link to="#0"><i className="fab fa-google-plus-g"></i></Link>
                        <Link to="#0"><i className="fab fa-instagram"></i></Link>
                    </div>
                </div>
            </div>
        </div>
    </aside>

    <aside class="side-info-wrapper show-all">
        <div class="side-info__wrapper d-flex align-items-center justify-content-between">
            <div class="side-info__logo">
                <a href="index-2.html">
                    <img src="assets/img/logo/logo.jpg" alt="logo"/>
                </a>
            </div>
            <div class="side-info__close">
                <a href="javascript:void(0);"><i class="far fa-times"></i></a>
            </div>
        </div>
        <div class="side-info">
            <div class="side-info__content mb-35">
                <h4 class="title">{translate(componentName, 'email', language)}</h4>
                <p>{translate(componentName, 'email', language)}</p>
                <a class="btn btn__small mt-20" href="contact.html">Contact us <span></span></a>
            </div>
            <div class="contact__info--wrapper mt-15">
                <h4 class="title mb-15">Contact us</h4>
                <ul class="contact__info list-unstyled">
                    <li>
                        <span><i class="fas fa-map-marker-alt"></i></span>
                        <p>{translate(componentName, 'address', language)}</p>
                    </li>
                    <li>
                        <span><i class="fas fa-phone"></i></span>
                        <p>{translate(componentName, 'phone', language)}</p>
                    </li>
                    <li>
                        <span><i class="fas fa-envelope-open-text"></i></span>
                        <p>{translate(componentName, 'email', language)}</p>
                    </li>
                </ul>
            </div>
            <div class="social-links mt-30">
                <a href="#0"><i class="fab fa-facebook-f"></i></a>
                <a href="#0"><i class="fab fa-twitter"></i></a>
                <a href="#0"><i class="fab fa-google-plus-g"></i></a>
                <a href="#0"><i class="fab fa-instagram"></i></a>
            </div>
        </div>
    </aside>
    </>
  )
}

export default Header;
